<template>
  <p>
    El etalómetro (aethelometer) realiza mediciones de absorción de una luz
    láser a través de un filtro que va captando las partículas del aire. En base
    a mediciones en 7 longitudes de onda de 370 a 950 nm determina la
    concentración de carbono negro equivalente en la atmósfera. Tiene un rango
    de medición de 0.01 a 100 ug/m3 con un flujo de 5 LPM y una frecuencia de
    medición por minuto. Se utiliza un cabezal de PM2.5 para la colecta. Este
    instrumento cumple con las exigencias del programa de Vigilancia Atmosférica
    Global de la Organización Mundial de Meteorología (VAG/OMM).
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/etalometro.webp"
    alt="Etalómetro"
  />
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Concentración de carbono negro (ug/m<sup>3</sup>)</li>
    <li>Porcentaje de biomasa quemada (%)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    Magee Scientific, AE33
  </p>
  <p>
    <b>País: </b> <br />
    Eslovenia
  </p>
  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.aerosolmageesci.com/products/aerosol

-magee-scientific-aethalometer/"
      target="_blank"
      >https://www.aerosolmageesci.com/products/aerosol
      -magee-scientific-aethalometer/</a
    >
  </p>
  <p>
    <b>Responsable: </b> <br />
    lsuarez@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  // Obtener el nombre de la ruta

  name: "FotometroSolar",
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
